/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, quota: NonNullable<unknown> }} Admin_Subscription_Rights_Usage_ValueInputs */

const fr_admin_subscription_rights_usage_value = /** @type {(inputs: Admin_Subscription_Rights_Usage_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.quota}`)
};

/**

* @param {Admin_Subscription_Rights_Usage_ValueInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_usage_value = /** @type {((inputs: Admin_Subscription_Rights_Usage_ValueInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Usage_ValueInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_usage_value(inputs)
});